export default __webpack_public_path__ + "static/media/poster.72aed792.png";